import Vue from 'vue';
import Component from 'vue-class-component';
import CmsDataProvider from '../../../../Providers/CmsDataProvider';

const cmsData = CmsDataProvider.get<videoContent>("VideoHeader");

interface MediaData {
	Url?: string;
	Format?: string;
}

interface videoContent {
	Title?: string,
	VimeoUrl?: string,
	VimeoUrlMobile?: string,
	HeaderVideo?: string,
	HeaderVideoMobile?: string,
	PrimaryHeaderVideo?: string,
	PrimaryHeaderVideoMobile?: string,
	HeaderImage?: string,
	HeaderImageMobile?: string
}

@Component({
	name: 'Header',
	components: {

	},
	async mounted(this: Header) {
		this.desktopVideo = this.getDesktopVideo();
		this.desktopPicture = this.getDesktopPicture();
		this.mobileVideo = this.getMobileVideo();
		this.mobilePicture = this.getMobilePicture();
	}
})

export default class Header extends Vue {
	public desktopVideo: MediaData[] | null = null;
	public desktopPicture: MediaData | null = null;
	public mobileVideo: MediaData[] | null = null;
	public mobilePicture: MediaData | null = null;
	public videoPaused: boolean = false;

	$refs !: {
		desktopVideo: HTMLVideoElement,
		desktopPicture: HTMLPictureElement,
		mobileVideo: HTMLVideoElement,
		mobilePicture: HTMLPictureElement,
	}

	//Player Controls
	public play() {
		this.$refs.desktopVideo?.play();
		this.$refs.mobileVideo?.play();

		this.videoPaused = false;
	}

	public pause() {
		this.$refs.desktopVideo?.pause();
		this.$refs.mobileVideo?.pause();

		this.videoPaused = true;
	}

	public startVideo() {
		setTimeout(() => {
			if (this.$refs.desktopVideo?.paused && this.$refs.desktopVideo?.readyState > 2) {
				this.$refs.desktopVideo?.play();
			} else {
				//vid is already playing so do nothing
			}
		}, 500)

		setTimeout(() => {
			if (this.$refs.mobileVideo?.paused && this.$refs.mobileVideo?.readyState > 2) {
				this.$refs.mobileVideo?.play();
			} else {
				//vid is already playing so do nothing
			}
		}, 500)
	}

	public restartVideo(retry: boolean = false) {
		if (this.$refs.desktopVideo) {
			this.$refs.desktopVideo.currentTime = 0;
			this.$refs.desktopVideo.play();
		} else if (retry) {
			//tries to load 1 more time but with a delay
			setTimeout(() => {
				this.restartVideo(false);
			}, 500);
		}

		if (this.$refs.mobileVideo) {
			this.$refs.mobileVideo.currentTime = 0;
			this.$refs.mobileVideo.play();
		} else if (retry) {
			//tries to load 1 more time but with a delay
			setTimeout(() => {
				this.restartVideo(false);
			}, 500);
		}
	}

	//Desktop Video/Picture
	public getDesktopVideo(): MediaData[] | null {
		var desktopHeader = this.getDesktopVideoFromHeader();
		if (desktopHeader != null) {
			return desktopHeader
		}

		var mobileHeader = this.getMobileVideoFromHeader();
		if (mobileHeader != null) {
			return mobileHeader
		}

		return null;
	}

	public getDesktopPicture(): MediaData | null {
		var desktopHeaderPicture = this.getDesktopPictureFromHeader();
		if (desktopHeaderPicture != null) {
			return desktopHeaderPicture
		}

		var mobileHeaderPicture = this.getMobilePictureFromHeader();
		if (mobileHeaderPicture != null) {
			return mobileHeaderPicture
		}

		return null;
	}

	//Mobile Video/Picture
	public getMobileVideo(): MediaData[] | null {
		var mobileHeader = this.getMobileVideoFromHeader();
		if (mobileHeader != null) {
			return mobileHeader
		}

		var desktopHeader = this.getDesktopVideoFromHeader();
		if (desktopHeader != null) {
			return desktopHeader
		}

		return null;
	}

	public getMobilePicture(): MediaData | null {
		var mobileHeaderPicture = this.getMobilePictureFromHeader();
		if (mobileHeaderPicture != null) {
			return mobileHeaderPicture
		}

		var desktopHeaderPicture = this.getDesktopPictureFromHeader();
		if (desktopHeaderPicture != null) {
			return desktopHeaderPicture
		}

		return null;
	}

	//Data
	public getDesktopVideoFromHeader(): MediaData[] | null {
		if (cmsData) {

			let videos: MediaData[] = [];

			if (cmsData.PrimaryHeaderVideo) videos.push({
				Url: cmsData.PrimaryHeaderVideo,
				Format: "video/webm"
			});

			if (cmsData.HeaderVideo) videos.push({
				Url: cmsData.HeaderVideo,
				Format: "video/mp4"
			});
			else if (cmsData.VimeoUrl) videos.push({
				Url: cmsData.VimeoUrl,
				Format: "video/mp4"
			});

			if (!videos.length) return null;
			return videos;
		}

		return null;
	}

	public getDesktopPictureFromHeader(): MediaData | null {
		if (cmsData) {
			if (cmsData.HeaderImage) return {
				Url: cmsData.HeaderImage,
				Format: cmsData.HeaderImage.substring(cmsData.HeaderImage.lastIndexOf(".") + 1)				
			}
		}

		return null;
	}

	public getMobileVideoFromHeader(): MediaData[] | null {
		if (cmsData) {

			let videos: MediaData[] = [];

			if (cmsData.PrimaryHeaderVideoMobile) videos.push({
				Url: cmsData.PrimaryHeaderVideoMobile,
				Format: "video/webm"
			});

			if (cmsData.HeaderVideoMobile) videos.push({
				Url: cmsData.HeaderVideoMobile,
				Format: "video/mp4"
			});
			else if (cmsData.VimeoUrlMobile) videos.push({
				Url: cmsData.VimeoUrlMobile,
				Format: "video/mp4"
			});

			if (!videos.length) return null;
			return videos;
		}

		return null;
	}

	public getMobilePictureFromHeader(): MediaData | null {
		if (cmsData) {
			if (cmsData.HeaderImageMobile) return {
				Url: cmsData.HeaderImageMobile,
				Format: cmsData.HeaderImageMobile.substring(cmsData.HeaderImageMobile.lastIndexOf(".") + 1)				
			}
		}

		return null;
	}
}